import { Button, DatePicker, Form, Tooltip } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import InputModalSelected from "../../../Components/InputModalSelected";
import TableAnalytic from "../Table";

import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import { GetCustomers, GetSPTestingCost } from "../../../API/GetData";
import ChartSPTestingCost from "../Charts/ChartSPTestingCost";
import AddSpaceBetweenCapital from "../utils/AddSpaceBetweenCapital";
import ExportPDF from "../utils/ExportPDF";
import ExportToExcel from "../utils/ExportToExcel";
import ToRupiah from "../utils/ToRupiah";

const SectionSPTestingCost = ({
  userData,
  columnsCustomer,
  defaultStartDate,
}) => {
  const [formSPTC] = Form.useForm();
  const [salesTestCost, setSalesTestCost] = useState([]);
  const [columnsSalesTestCost, setColumnsSalesTestCost] = useState([]);
  const [isLoadingSPTC, setIsLoadingSPTC] = useState(false);

  const onFilterDataSPTC = async (values) => {
    try {
      setIsLoadingSPTC(true);

      // Pastikan nilai CustomerName berupa array
      let customerData = values.CustomerName;
      if (customerData && !Array.isArray(customerData)) {
        customerData = [customerData];
      }

      const CustomerId = customerData
        ? customerData.map((item) => item.CustomerId).join(",")
        : "";

      const startDate = values.StartDate.format("YYYY-MM-DD");
      const endDate = values.EndDate.format("YYYY-MM-DD");

      let res = await GetSPTestingCost(
        // defaultStartDate.format("YYYY-MM-DD"),
        startDate,
        endDate
      );
      if (userData.Role === "User") {
        res = res.filter((item) => item.CustomerId === userData.CustomerId);
      } else if (CustomerId) {
        res = res.filter((item) => CustomerId.includes(item.CustomerId));
      }
      setSalesTestCost(res);

      if (res.length > 0) {
        const cols = Object.keys(res[0])
          .filter((key) => key !== "AccountId" && key !== "CustomerId")
          .map((key) => ({
            title: AddSpaceBetweenCapital(key),
            dataIndex: key,
            key: key,
            render: (val) => {
              if (key === "TestingCost") return ToRupiah(val);
              return val;
            },
          }));
        setColumnsSalesTestCost(cols);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingSPTC(false);
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [dataCustomer, setDataCustomer] = useState([]);
  const [selectCustomer, setSelectCustomer] = useState(null);
  const CustomerNames =
    selectCustomer &&
    selectCustomer.map((item) => item.CustomerName).join(", ");
  const CustomerId =
    selectCustomer && selectCustomer.map((item) => item.CustomerId).join(",");
  const [openCustomer, setOpenCustomer] = useState(null);
  const [AccountId, setAccountId] = useState(null);
  const [Date, setDate] = useState(null);

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        setIsLoading(true);
        const res = await GetCustomers();
        // console.log('Data Customer', res);

        // if (userData.Role === "Admin") {
        //   const selectDefaultCS = res[0];
        //   setSelectCustomer(selectDefaultCS);
        // }
        setDataCustomer(res);
      } catch (error) {
        console.log(error);
      }
      setIsLoading(false);
    };
    if (openCustomer) {
      fetchCustomer();
      setOpenCustomer(false);
    }
    setAccountId(selectCustomer ? selectCustomer.AccountId : "");
    setDate(dayjs().format("YYYY-MM-DD"));
  }, [openCustomer, selectCustomer, userData.Role]);

  useEffect(() => {
    if (selectCustomer) {
      formSPTC.setFieldsValue({
        CustomerName: CustomerNames,
        // Date: dayjs(),
      });
      setAccountId(AccountId);
    }
  }, [AccountId, CustomerNames, formSPTC, selectCustomer]);

  const onResetFilter = () => {
    formSPTC.resetFields();
    setSalesTestCost([]);
  };

  return (
    <div className="bg-white p-4 rounded-md mb-5">
      <div className="flex items-center gap-2 mb-2">
        <h1 className="text-xl font-bold uppercase">Testing Cost</h1>
        <div className="flex items-center">
          <Tooltip title="Export to PDF">
            <Button
              icon={<FilePdfOutlined />}
              type="text"
              onClick={() =>
                ExportPDF(
                  salesTestCost,
                  columnsSalesTestCost,
                  "Testing Cost"
                )
              }
            />
          </Tooltip>
          <Tooltip title="Export to Excel">
            <Button
              icon={<FileExcelOutlined />}
              type="text"
              onClick={() => ExportToExcel(salesTestCost, "Testing Cost")}
            />
          </Tooltip>
        </div>
      </div>
      <div className="flex flex-col gap-4 mb-5">
        <Form
          form={formSPTC}
          layout="vertical"
          onFinish={onFilterDataSPTC}
          autoComplete="off"
          className="relative border-0 p-4"
          initialValues={{
            StartDate: defaultStartDate,
            EndDate: dayjs(),
          }}
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {userData.Role === "Admin" && (
              <InputModalSelected
                title="CUSTOMER"
                label="Customer"
                name="CustomerName"
                dataSource={dataCustomer}
                loading={isLoadingSPTC}
                columns={columnsCustomer}
                onData={(values) => setSelectCustomer(values)}
                onOpenModal={(values) => setOpenCustomer(values)}
                onRequired={true}
              />
            )}
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
            <div className="mb-4">
              <Form.Item label="Start Date" name="StartDate" className="w-full">
                <DatePicker className="w-full" />
              </Form.Item>
            </div>
            <Form.Item label="End Date" name="EndDate" className="w-full">
              <DatePicker className="w-full" />
            </Form.Item>
          </div>
          <div className="flex justify-end gap-2">
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
            <Button
              htmlType="button"
              onClick={() => onResetFilter(formSPTC, setSalesTestCost)}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="w-full">
          <TableAnalytic
            columns={columnsSalesTestCost}
            dataSource={salesTestCost}
            isLoading={isLoadingSPTC}
          />
        </div>
        <div className="w-full">
          <ChartSPTestingCost dataSource={salesTestCost} />
        </div>
      </div>
    </div>
  );
};

export default SectionSPTestingCost;
